export const gateNameConstants = [
  "",
  "main",
  "mainOuter",
  "mainInner",
  "pedestrian",
  "barrier",
  "barrierInner",
  "barrierOuter",
  "barrierExit",
  "barrierEntry",
] as const
export type GateNames = typeof gateNameConstants[number]

export class IotGateModel {
  iotDeviceGateId!: number
  name!: GateNames
  gateId!: number
}
